import { render, staticRenderFns } from "./GetPrizePuzzle.vue?vue&type=template&id=431802fc&scoped=true&"
import script from "./GetPrizePuzzle.vue?vue&type=script&lang=js&"
export * from "./GetPrizePuzzle.vue?vue&type=script&lang=js&"
import style0 from "./GetPrizePuzzle.vue?vue&type=style&index=0&id=431802fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431802fc",
  null
  
)

export default component.exports